import { createSlice } from '@reduxjs/toolkit';

interface RoleChangeNotificationState {
    isShowDialog: boolean;
}

const initialState: RoleChangeNotificationState = {
    isShowDialog: false,
};

export const roleChangeNotificationSlice = createSlice({
    name: 'roleChangeNotification',
    initialState,
    reducers: {
        setShowRoleChangeNotificationAction: (state, action) => {
            state.isShowDialog = action.payload;
        },
    },
});

export const { setShowRoleChangeNotificationAction } =
    roleChangeNotificationSlice.actions;

export default roleChangeNotificationSlice.reducer;
